// @flow

export function apiHttpUrl(path: string) {
  if (window.env.apiHost) {
    var protocol = window.env.apiSecure ? "https://" : "http://";
    return protocol + window.env.apiHost + path;
  }
  return path;
}

export function apiWebsocketUrl(path: string) {
  if (window.env.apiHost) {
    var protocol = window.env.apiSecure ? "wss://" : "ws://";
    return protocol + window.env.apiHost + path;
  }
  return path;
}
